var render = function render(){var _vm=this,_c=_vm._self._c;return _c('GradientButton',{staticClass:"ml-2",attrs:{"title":_vm.label,"small":true,"button-size":"medium","callout":""},on:{"gradientButtonClicked":function($event){return _vm.$emit('click')}},nativeOn:{"click":function($event){$event.stopPropagation();}}})
}
var staticRenderFns = []

export { render, staticRenderFns }